<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-widescreen-4.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec4')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec4Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Wordpress",
    "pageDesc":"Enjoy custom wordpress development services that starts with plugins and themes customization to API integrations and ecommerce development.",
    "mantra":"Revolutionizing WordPress development.",
    "sec1Items":{
      "1":{
        "title":"API integration",
        "desc":"Enhance your website experience and support your business by adding external services to your website with a seamless API integration."
      },
      "2":{
        "title":"Migration",
        "desc":"Done with your current development method? We help you migrate to WordPress without data loss or extra complications."
      },
      "3":{
        "title":"WordPress theme customization and development",
        "desc":"Whether starting from scratch or adding little tweaks, we help you add your brand personality to the default WordPress themes."
      },
      "4":{
        "title":"WordPress Plugins development",
        "desc":"Enjoy endless possibilities with plugins developed or integrated into your website."
      },
      "5":{
        "title":"Maintenance and consulting",
        "desc":"Keeping your website up and running and fixing all the issues for a better and consistent performance."
      }
    },
    "sec2":"Rediscover the WordPress powers.",
    "sec2Items":{
      "1":{
        "title":"Customization",
        "desc":"Applying all the necessary features and taking the design beyond the wordpress default themes."
      },
      "2":{
        "title":"Arabic language support",
        "desc":"We help you get the design you need with all the customization supporting the arabic language."
      },
      "3":{
        "title":"Easy admin panel",
        "desc":"Providing you with an easy to navigate admin panel that lets you go creative with your content creation."
      },
      "4":{
        "title":"Responsiveness",
        "desc":"Enhancing the website for a seamless experience across different devices and screen resolutions."
      },
      "5":{
        "title":"User friendly",
        "desc":"Mixing the UX standards with WordPress capabilities to create memorable experiences."
      },
      "6":{
        "title":"Clean code",
        "desc":"Capitalizing on cutting edge practices and optimizing the code for higher performance rate."
      }
    },
    "sec3":"We have got you covered from design to development.",
    "sec3Items":{
      "1":{
        "title":"SEO friendly",
        "desc":"Crawlers are familiar with WordPress defaults which makes it easier for your website to rank higher on engines."
      },
      "2":{
        "title":"Open source",
        "desc":"WordPress is supported by millions of developers all over the world that’s why it’s always updated and maintained with the best practices."
      },
      "3":{
        "title":"Easily managed",
        "desc":"Even non technicians can add content, update the website and install plugins easily using WordPress."
      }
    },
    "sec4":"From blogs to e-commerce, corporate websites and even news.",
    "sec4Items":{
      "1":{
        "title":"Understanding requirements",
        "desc":"We start with your business needs and industry analysis."
      },
      "2":{
        "title":"Analyzing and planning",
        "desc":"Planning out all the project details, pages and features required."
      },
      "3":{
        "title":"Developing and iterations",
        "desc":"Creating versions and going through many iterations until we reach maturity."
      },
      "4":{
        "title":"Delivery and maintenance",
        "desc":"Celebrating your success and staying in touch to support your business growth."
      }
    },
    "cta":"Get your custom <br> wordpress website now"
  },
  "ar": {
    "pageTitle":"برمجة وتصميم ووردبريس",
    "pageDesc":"احصل على ما تحتاجه من تصميم وبرمجة ووردبريس بالمكونات الإضافية والقوالب المخصصة وتكامل API و برمجة التجارة الإلكترونية.",
    "mantra":"صمم وطور قوالب ووردبريس |تتناسب مع احتياجاتك.",
    "sec1Items":{
      "1":{
        "title":"تكامل واجهة برمجة التطبيقات (API)",
        "desc":"ادعم عملك التجاري وعزز من التجربة التي تمنحها لعملائك عن طريق إضافة خدمات خارجية إلى موقعك ولا تقلق سوف تحصل على تكامل سلس مع واجهة برمجة التطبيقات."
      },
      "2":{
        "title":"الانتقال (Migration)",
        "desc":"سئمت من طرق البرمجة الحالية التي تعتمد عليها؟! سوف نساعدك على الانتقال إلى ووردبريس بكل سهولة وأمان دون فقد البيانات أو وجود أي تعقيدات."
      },
      "3":{
        "title":"برمجة وتصميم قوالب ووردبريس مخصصة",
        "desc":"سواء كنت تبدأ من الصفر أو حتى تجرى تعديلات بسيطة، سوف نساعدك على إضافة روح هويتك التجارية إلى قوالب الووردبريس الافتراضية."
      },
      "4":{
        "title":"المكونات الإضافات للووردبريس(Plugins)",
        "desc":"استمتع بإمكانيات لا حصر لها مع المكونات الإضافية المتقدمة أو المدمجة في موقعك."
      },
      "5":{
        "title":"الصيانة والاستشارات",
        "desc":"نساعدك على الحفاظ على أداء موقعك وإصلاح جميع المشكلات فورًا للحصول على أداء أفضل وثابت."
      }
    },
    "sec2":"تعرف على ما يمكن الووردبريس القيام به لأجلك.",
    "sec2Items":{
      "1":{
        "title":"التخصيص",
        "desc":"يمكنك الاستفادة من جميع المميزات الضرورية والحصول على تصميم يتجاوز القوالب الافتراضية للووردبريس المتعارف عليها."
      },
      "2":{
        "title":"يدعم اللغة العربية",
        "desc":"نساعدك في الحصول على التصميم الذي تحتاجه إليه بالإضافة إلى دعم  للغة العربية."
      },
      "3":{
        "title":"لوحة إدارة سهلة الاستخدام (Admin panel)",
        "desc":"يوفر لك الووردبريس وسيلة سهلة للتنقل في لوحة الإدارة والتي تساعد على إطلاق العنان لخيالك والإبداع أثناء إنشاء المحتوى."
      },
      "4":{
        "title":"متجاوب",
        "desc":"يساعدك الووردبريس على تقديم تجربة مميزة وسهلة عبر جميع الأجهزة المختلفة وفقًا لدقة الشاشة."
      },
      "5":{
        "title":"سهل الاستخدام",
        "desc":"المزج بين معايير تجربة المستخدم و إمكانات الووردبريس يساعدك على إنشاء تجارب تصفح لا تنسى."
      },
      "6":{
        "title":"كود واضح",
        "desc":"يمكنك الاستفادة من الممارسات المتطورة وتحسين الكود من أجل تحقيق معدل أداء عالى."
      }
    },
    "sec3":"احصل على تجربة كاملة من التصميم إلى البرمجة.",
    "sec3Items":{
      "1":{
        "title":"تحسين محركات البحث",
        "desc":"عناكب محركات البحث تتعرف بصورة أكبر على الافتراضات التي يمتلكها الووردبريس؛ مما يساعد موقعك على الترتيب في محركات البحث في النتائج الأولي وسهولة عثور عملائك عليك."
      },
      "2":{
        "title":"مصدر مفتوح",
        "desc":"يُدعم الووردبريس من قبل ملايين المطورين في جميع أنحاء العالم؛ ولهذا السبب يتم تحديثه دائمًا وصيانته بأفضل الممارسات."
      },
      "3":{
        "title":"سهل الإدارة",
        "desc":"لا يتطلب العمل على إضافة محتوى جديد أو تحديث موقعك أو إضافة مكونات جديدة الإعتماد على المبرمجين فقط، حيث يمكنك أنت أيضًا القيام بذلك بسهولة."
      }
    },
    "sec4":"من التجارة الإلكترونية ومواقع الشركات إلى المدونات حتى مواقع الأخبار.",
    "sec4Items":{
      "1":{
        "title":"فهم المتطلبات",
        "desc":"نبدأ بتحليل احتياجات عملك والصناعة التي تعمل بها."
      },
      "2":{
        "title":"التحليل والتخطيط",
        "desc":"نقوم بتخطيط جميع تفاصيل المشروع والصفحات والمميزات المطلوبة."
      },
      "3":{
        "title":"البرمجة والمراجعات",
        "desc":"نقوم بإنشاء الإصدارات ونمر بالعديد من مراحل المراجعات حتى نصل إلى الجودة التي نبحث عنها."
      },
      "4":{
        "title":"التسليم والصيانة",
        "desc":"الآن، يمكنك الاحتفال بنجاحك حيث يمكنك البقاء على اتصال مع عملائك."
      }
    },
    "cta":"احصل على موقع ووردبريس <br> مخصص لأجلك الآن!"
  }
}
</i18n>
